import React, { useEffect, useRef, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import api from "../../api/api";
import { useLocation } from "react-router-dom";
import { DateTime } from "luxon";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { format, parse } from "date-fns";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { CircularProgress } from "@mui/material";
import ReactDOM from "react-dom";
import dayjs from "dayjs";
const EcpModal = ({ setEcpModal, previousdate,setSeverity, setOpen, setAlertMessage,fetchdata }) => {
  const [rows, setRows] = useState([
    {
      equipment_id: 0,
      equipment_name: "",
      hours: "",
      quantity: 0,
      unit: "",
      group_id: 1,
    },
  ]);

  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [jobCode, setJobCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedJobName, setSelectedJobName] = useState("");
  const InputRef = useRef(null);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [equipmentSuggestions, setEquipmentSuggestions] = useState([]);
  const [filteredEquipSuggestions, setFilteredEquipSuggestions] = useState({});
  const [showEquipSuggestions, setShowEquipSuggestions] = useState({});
  const [jobCodeLoading, setJobCodeLoading] = useState(false);
const [equipmentLoading, setEquipmentLoading] = useState(false);
const [hoveredIndex, setHoveredIndex] = useState(-1);
const [hoveredEquipIndex, setHoveredEquipIndex] = useState({});
const [jobNotFound, setJobNotFound] = useState(false);
const [validationErrors, setValidationErrors] = useState({});

  const date = queryParams.get("date");


const [selectedDate, setSelectedDate] = useState(() => {
  if (previousdate) {
    return dayjs(previousdate).toDate(); // ✅ prefer previousdate if provided
  } else if (date) {
    return dayjs(date, "YYYY-MM-DD").toDate(); // ✅ query param date
  } else {
    return dayjs().toDate(); // ✅ fallback current date
  }
});
    const supervisorid = queryParams.get("supervisorid");
  const companyid = queryParams.get("companyid");

  const equipmentRefs = useRef([]);
  const handleAddRow = () => {
    setRows([
      ...rows,
      {
        equipment_id: 0,
        equipment_name: "",
        hours: "",
        quantity: 0,
        unit: "",
        group_id: 1,
      },
    ]);
  };
const validateForm = () => {
  let errors = {};

  // ✅ Job Number validation
  if (!jobCode.trim()) {
    errors.jobCode = true;
  }

  // ✅ Rows validation
  rows.forEach((row, index) => {
    let rowErrors = {};
    if (!row.equipment_id || !row.equipment_name.trim()) {
      rowErrors.equipment_name = true;
    }
    if (!row.hours) {
      rowErrors.hours = true;
    }
    if (!row.quantity || row.quantity <= 0) {
      rowErrors.quantity = true;
    }
    if (!row.unit.trim()) {
      rowErrors.unit = true;
    }
    if (Object.keys(rowErrors).length > 0) {
      errors[index] = rowErrors;
    }
  });

  setValidationErrors(errors);
  return Object.keys(errors).length === 0;
};


  const isFormValid = () => {
    const hasJobCode = jobCode.trim() !== "";
    let hasEntryDate = false;
    if (typeof selectedDate === 'string') {
      hasEntryDate = selectedDate.trim() !== "";
    } else if (selectedDate instanceof Date) {
      hasEntryDate = !isNaN(selectedDate.getTime());
    }
    

    const allRowsValid =
      rows.length > 0 &&
      rows.every(
        (row) =>
          row.equipment_id &&
          row.hours &&
          row.quantity > 0 &&
          row.unit.trim() !== ""
      );

    return hasJobCode && hasEntryDate && allRowsValid;
  };

  const handleChange = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = field === "quantity" ? Number(value) : value;
    setRows(updatedRows);


     setValidationErrors((prev) => {
    const newErrors = { ...prev };
    if (newErrors[index]) {
      delete newErrors[index][field];
      if (Object.keys(newErrors[index]).length === 0) {
        delete newErrors[index]; // remove empty object
      }
    }
    return newErrors;
  });
  };

  const fetchSuggestions = async (query) => {
    try {
      setJobCodeLoading(true); // 
      if (!query) {
        setSuggestions([]);
        setShowSuggestions(false);
        setSelectedJobName("");
        return;
      }
  setJobNotFound(false)
      const response = await api.get(`/v1/timesheets/get-jobs`, {
        params: {
          company_id: queryParams.get("companyid"),
          job_num: query,
        },
      });
if(response.status==201){
  setJobNotFound(true)
}
      let fetchedSuggestions =
        response.status === 200 ? response.data || [] : [];

      // Manually include "0000 - Overhead" if relevant
      if (/^0{1,4}$/.test(query)) {
        const overheadJob = {
          job_num: "0000",
          job_name: "Overhead",
        };

        // Avoid duplicates
        const alreadyExists = fetchedSuggestions.some(
          (job) => job.job_num === "0000"
        );
        if (!alreadyExists) {
          fetchedSuggestions = [overheadJob, ...fetchedSuggestions];
        }
        setJobNotFound(false)
      }

      setSuggestions(fetchedSuggestions);
      setShowSuggestions(true);
    } catch (error) {
      console.error("Error fetching jobcodes:", error);
      setJobNotFound(true)
    }
     finally {
    setJobCodeLoading(false); // End loader
  }
  };
// Convert user entered hours into HH:mm:ss
const formatHoursToTime = (value) => {
  if (!value || isNaN(value)) return "00:00:00";

  const num = parseFloat(value);

  // Case 1: no decimal → hours only
  if (!String(value).includes(".")) {
    const hours = Math.floor(num);
    return `${String(hours).padStart(2, "0")}:00:00`;
  }

  const [hoursPart, decimalPart] = String(value).split(".");
  const hours = parseInt(hoursPart || "0", 10);

  let minutes = 0;

  if (decimalPart.length === 1) {
    // Single digit after decimal → multiply by 6
    minutes = parseInt(decimalPart) * 6;
  } else {
    // First 2 digits after decimal
    minutes = parseInt(decimalPart.substring(0, 2), 10);
  }

  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
    2,
    "0"
  )}:00`;
};
useEffect(() => {
  // Save current scroll position
  const scrollY = window.scrollY;
  document.body.style.position = "fixed";
  document.body.style.top = `-${scrollY}px`;
  document.body.style.width = "100%";

  return () => {
    // Restore scroll position
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.width = "";
    window.scrollTo(0, scrollY);
  };
}, []);

  const fetchEqupmentSuggestions = async () => {
    try {
      setEquipmentLoading(true); 
      const response = await api.get(`/v1/timesheets/get-equipment`, {
        params: {
          company_id: queryParams.get("companyid"),
        },
      });
      if (response.status === 200) {
        setEquipmentSuggestions(response.data || []);
      }
    } catch (error) {
      console.error("Error fetching equipment:", error);
    }
    finally {
    setEquipmentLoading(false); // End loader
  }
  };

  useEffect(() => {
    fetchEqupmentSuggestions();
  }, []);

  const handleSave = async () => {
    if(jobNotFound){
       setAlertMessage("Job Code Not Found");
        setSeverity("error");
        setOpen(true);
      return
    }
      const isValid = validateForm(); // ✅ run validation
  if (!isValid) {
    setAlertMessage("Please fill all required fields.");
    setSeverity("error");
    setOpen(true);
    return;
  }
    try {
      setLoading(true);
    const sanitizedRows = rows.map((row) => {
      const { equipment, ...rest } = row;
      return {
        ...rest,
        hours: formatHoursToTime(row.hours), // ✅ Convert to HH:mm:ss
      };
    });
     const formattedDate = selectedDate ? format(selectedDate, 'yyyy-MM-dd') : '';

      const response = await api.post(`/v1/timesheets/equipment/create`, {
        companyid: companyid,
        supervisorid: supervisorid,
        job_id: jobCode,
        jobname: selectedJobName,
        date:formattedDate,
        eqprow: sanitizedRows,
      });
      if (response.status == 200) {
        setAlertMessage("Submitted successfully.");
        setSeverity("success");
        setOpen(true);
        fetchdata()
        setEcpModal(false);
      } else {
        setAlertMessage(response.message);
        setSeverity("info");
        setOpen(true);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleJobCodeSelect = (code) => {
    setJobCode(code.job_num);
    setSelectedJobName(code.job_name);
    setSuggestions([]);
    setShowSuggestions(false);
  };

  const handleEquipmentInputChange = (index, value) => {
    handleChange(index, "equipment_name", value); // Correctly updating 'equipment_name'

    // Filter equipment suggestions based on the input value
const filtered = equipmentSuggestions.filter((eq) => {
  const search = value.toLowerCase();

  return (
    eq.equipmentname.toLowerCase().includes(search) ||
    eq.shortname.toLowerCase().includes(search) ||
    String(eq.id).includes(search)   // ✅ support search by id
  );
});
    // Update filtered suggestions and visibility of suggestion list
    setFilteredEquipSuggestions((prev) => ({ ...prev, [index]: filtered }));
    setShowEquipSuggestions((prev) => ({ ...prev, [index]: true }));
  };

  const handleEquipmentSelect = (index, item) => {
    const updatedRows = [...rows];
    updatedRows[index].equipment_id = item.id;
    updatedRows[index].equipment_name = item.equipmentname;
    setRows(updatedRows);
    setShowEquipSuggestions((prev) => ({ ...prev, [index]: false }));
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        InputRef.current &&
        !InputRef.current.contains(event.target) &&
        equipmentRefs.current.every((ref) => !ref?.contains(event.target))
      ) {
        setShowSuggestions(false);
        setHoveredIndex(-1);
        setShowEquipSuggestions({});
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleDeleteRow = (index) => {
    const updatedRows = rows.filter((_, i) => i !== index);
    setRows(updatedRows);
  };
  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

console.log('formatted',selectedDate)
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="relative w-[60%]   bg-white rounded-xl p-2 text-start border border-gray-300 shadow-sm">
        {/* Header */}
        <div className="flex border-b py-4 px-6 justify-between items-center">
          <p className="font-poppins font-semibold text-[22px]">
            Add Equipment Time
          </p>
          <button
            onClick={() => setEcpModal(false)}
            className="text-gray-500 hover:text-gray-700"
          >
            <CloseIcon />
          </button>
        </div>

        {/* Modal Content */}
        <div className="px-6 py-4">
          <div className=" pb-4">
            <label className="block text-sm font-medium mb-1 text-left">
              Entry Date
            </label>
            <DatePicker
      selected={selectedDate}
      onChange={handleDateChange}
      className="w-full border rounded px-3 py-2"
      dateFormat="MM-dd-yyyy"
      placeholderText="MM-DD-YYYY"
    />
          </div>

          {/* Job Number */}
          <div className="flex w-full justify-between mb-8">
            <div className="relative" ref={InputRef}>
              <label className="block text-sm text-left font-medium mb-1">
                Job Number
              </label>
              <input
                type="text"
                placeholder="Job Number"
                value={jobCode}
                onChange={(e) => {
                  const val = e.target.value;
                  setJobCode(val);
                  setSelectedJobName("");
                  fetchSuggestions(val);
                  setValidationErrors((prev) => {
    const newErrors = { ...prev };
    if (newErrors.jobCode) {
      delete newErrors.jobCode;
    }
    return newErrors;
  });
                }}
                 onKeyDown={(e) => {
    if (e.key === "Tab" && showSuggestions && hoveredIndex !== -1) {
      e.preventDefault(); // Prevent default tab behavior
      handleJobCodeSelect(suggestions[hoveredIndex]); // Select the hovered item
    }
  }}
               className={`w-full border rounded px-3 py-2 ${
    validationErrors.jobCode ? "border-red-500" : "border-gray-300"
  }`}
              />
             {showSuggestions && (
  <div className="absolute z-10 mt-1 left-0 text-start bg-white border border-gray-200 rounded-md shadow-lg max-h-[400px] overflow-y-auto text-sm w-full whitespace-nowrap">
    {jobCodeLoading ? (
      <div className="p-2  text-gray-500 flex w-full justify-center items-center"><CircularProgress size={20} /></div>
    ) : suggestions.length > 0 ? (
      suggestions.map((code, index) => (
        <div
          key={index}
          onClick={() => handleJobCodeSelect(code)}
         onMouseEnter={() => setHoveredIndex(index)} // Track hovered item
    className={`px-2 py-1 cursor-pointer hover:bg-gray-100 ${
      hoveredIndex === index ? "bg-gray-100" : ""
    }`}
        >
          {code.job_num} - {code.job_name}
        </div>
      ))
    ) : (
      <div className="p-2 flex w-full justify-center text-gray-500">No results found.</div>
    )}
  </div>
)}

              {selectedJobName && (
                <p className="text-sm text-gray-600 my-0 mt-1 text-left">
                  {selectedJobName}
                </p>
              )}

               {jobNotFound&&<p className="text-xs text-red-500 mt-1">No Job code found</p>}
            </div>

            {/* Add Row Button */}
            <div className="mb-4 text-right">
              <button
                onClick={handleAddRow}
                className="flex items-center gap-1 bg-gray-100 hover:bg-gray-200 border border-gray-300 text-sm px-4 py-2 rounded-md"
              >
                Add Row <AddIcon fontSize="small" />
              </button>
            </div>
          </div>

          {/* Table Header */}
          <div className="grid grid-cols-6 bg-gray-100 font-semibold px-4 py-2 mb-2 rounded">
            <span className="col-span-2  text-center">Equipment</span>
            <span className="ml-1 text-center">Hours</span>
            <span className="ml-1 text-center">Quantity</span>
            <span className="ml-4 text-center">Unit No.</span>
            <span className="ml-6 text-center">Action</span>
          </div>

          {/* Dynamic Rows */}
          <div className="space-y-2 max-h-[40vh] overflow-y-auto ">
            {rows.map((row, index) => (
              <div key={index} className="grid grid-cols-6 gap-1">
                <div
                  className="relative col-span-2"
                  ref={(el) => (equipmentRefs.current[index] = el)}
                >
                  <input
                    type="text"
               placeholder="Search by Equipment Name or ID"
                    value={row.equipment_name} // Bind the value of the input to equipment_name
                    onChange={(e) =>
                      handleEquipmentInputChange(index, e.target.value)
                    } // Corrected change handler
                    onKeyDown={(e) => {
    if (
      e.key === "Tab" &&
      showEquipSuggestions[index] &&
      filteredEquipSuggestions[index]?.length > 0 &&
      hoveredEquipIndex[index] !== undefined
    ) {
      e.preventDefault(); // prevent focus shift
      handleEquipmentSelect(index, filteredEquipSuggestions[index][hoveredEquipIndex[index]]);
    }
  }}
         className={`w-full px-3 py-2 border rounded-md ${
    validationErrors[index]?.equipment_name ? "border-red-500" : "border-gray-300"
  }`}
                  />
  {showEquipSuggestions[index] &&
  ReactDOM.createPortal(
    <ul
      className="absolute z-50 bg-white border border-gray-200 rounded-md shadow-md max-h-40 overflow-y-auto text-sm w-[200px]"
      style={{
        top: equipmentRefs.current[index]?.getBoundingClientRect().bottom + window.scrollY,
        left: equipmentRefs.current[index]?.getBoundingClientRect().left + window.scrollX,
        width: equipmentRefs.current[index]?.offsetWidth || "auto",
      }}
    >
      {equipmentLoading ? (
        <div className="p-2 text-gray-500 flex w-full justify-center items-center">
          <CircularProgress size={20} />
        </div>
      ) : filteredEquipSuggestions[index]?.length > 0 ? (
        filteredEquipSuggestions[index].map((item, i) => (
          <li
            key={item.id}
            className={`px-3 py-2 cursor-pointer hover:bg-gray-100 ${
              hoveredEquipIndex[index] === i ? "bg-gray-100" : ""
            }`}
            // onClick={() => handleEquipmentSelect(index, item)}
            // onMouseEnter={() =>
            //   setHoveredEquipIndex((prev) => ({ ...prev, [index]: i }))
            // }
             onMouseDown={() => handleEquipmentSelect(index, item)} // 👈 FIXED
  onMouseEnter={() =>
    setHoveredEquipIndex((prev) => ({ ...prev, [index]: i }))
  }
          >
      {item.id} - {item.equipmentname} ({item.shortname})
          </li>
        ))
      ) : (
        <li className="px-3 flex w-full justify-center py-2 text-gray-500">
          No results found.
        </li>
      )}
    </ul>,
    document.body
  )}

                </div>

               <input
  type="number"
  step="0.01" // allows decimal hours like 10.25
  value={row.hours || ""}
  onChange={(e) => {
    const value = e.target.value;
    handleChange(index, "hours", value);
  }}
  placeholder="Enter hours"
 className={`w-full px-3 py-2 border rounded-md ${
    validationErrors[index]?.hours ? "border-red-500" : "border-gray-300"
  }`}
/>


                {/* Quantity */}
                <input
                  type="text"
                  placeholder="Quantity"
                  value={row.quantity}
                  onChange={(e) =>
                    handleChange(index, "quantity", e.target.value)
                  }
               className={`w-full px-3 py-2 border rounded-md ${
    validationErrors[index]?.quantity ? "border-red-500" : "border-gray-300"
  }`}
                />

                {/* Units */}
                <input
                  type="text"
                  placeholder="Unit No."
                  value={row.unit}
                  onChange={(e) => handleChange(index, "unit", e.target.value)}
                 className={`w-full px-3 py-2 border rounded-md ${
    validationErrors[index]?.unit ? "border-red-500" : "border-gray-300"
  }`}
                />
                <div className="text-center">
                  <button
                    onClick={() => handleDeleteRow(index)}
                    className="text-red-600 w-full h-full rounded-md border border-red-500 hover:text-red-800 font-semibold"
                    title="Delete Row"
                  >
                    <DeleteForeverIcon />
                  </button>
                </div>
              </div>
            ))}
          </div>
          
        </div>

        {/* Save Button */}
        <div className="mt-4 flex justify-end w-full">
          <button
  onClick={handleSave}
  className="px-6 py-2 rounded-lg text-white bg-[#8B1D1D]"
>
  {loading ? "Saving..." : "Save changes"}
</button>

          {/* <button
            onClick={handleSave}
            disabled={!isFormValid()}
            className={`px-6 py-2   rounded-lg  text-white ${
              !isFormValid()  ? 'bg-[#944f4f]' : 'bg-[#8B1D1D]'
            }`}
          >
            {loading ? "Saving..." : "Save changes"}
          </button> */}
        </div>
      </div>
    </div>
  );
};

export default EcpModal;
